import styled from 'styled-components'

import { RectangleNetworkBackground } from '@root/shared/ui/background/rectangle-network'
import { Separator as Separator_ } from '@root/shared/ui-kit'

import type { ClassNameProps } from '@root/shared/react'
import type { ReactNode } from 'react'

type DialogAnnouncementProps = {
  header: ReactNode
  children?: ReactNode
  footer?: ReactNode
  withSeparator?: boolean
} & ClassNameProps

export const DialogAnnouncement = ({
  className,
  header,
  children,
  footer,
  withSeparator = false,
}: DialogAnnouncementProps) => (
  <Root className={className}>
    <Header>
      <GlowingPrimary />
      {header}
    </Header>
    {withSeparator ? <Separator_ /> : undefined}
    {children ? <Body>{children}</Body> : undefined}
    {footer ? <Footer>{footer}</Footer> : undefined}
  </Root>
)

const Root = styled.div`
  background: var(--background-1)
    radial-gradient(
      63.28% 63.28% at 50% 1.87%,
      rgba(var(--background-2-rgb), 0.14) 0%,
      rgba(var(--background-2-rgb), 0.02) 100%
    );
  backdrop-filter: blur(16px);

  &::after {
    content: '';
    z-index: -1;
    position: absolute;
    width: 100%;
    top: 20%;
    left: 0;
    bottom: 0;
    opacity: 0.2;
    background: radial-gradient(
      80% 60% at 50% 100%,
      rgba(var(--primary-9-rgb), 0.9) 0%,
      transparent 100%
    );
  }
`

const Header = styled.div`
  background: var(--announcement-header-background);
  position: relative;
  overflow: hidden;

  &::before {
    ${RectangleNetworkBackground}
    content: '';

    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.3;
  }
`

const Body = styled.div`
  background: var(--announcement-body-background);
`
const Footer = styled.div`
  background: var(--announcement-footer-background);
`

const GlowingPrimary = styled.span`
  background-image: radial-gradient(
    240px 150px at 50% -30px,
    var(--primary-9) 0,
    var(--primary-9) 35%,
    var(--primary-9) 5%,
    transparent 100%
  );
  position: absolute;
  width: 100%;
  height: 200px;
  left: 0;
  top: 0;
  opacity: 0.5;
`
